import {
    CASOS_LIST,
    CASOS_FULLLIST,
    CASOS_LISTA,
    CASOS_FILTER,
    CASOS_CREATE,
    CASOS_CREATE_FORM,
    CASOS_UPDATE,
    CASOS_UPDATE_SUCCESS,
    CASOS_CREATE_SUCCESS,
    CASOS_CREATE_FORM_SUCCESS,
    CASOS_LIST_SUCCESS,
    CASOS_FULLLIST_SUCCESS,
    CASOS_REQUEST_FAILED,
    CASOS_READ,
    CASOS_READ_SUCCESS,

  } from "./actionTypes";
  
  export const casosList = () => {
    return {
      type: CASOS_LIST,
      payload: {},
    };
  };
  export const casosFullList = () => {
    return {
      type: CASOS_FULLLIST,
      payload: {},
    };
  };
  export const casosLista = () => {
    return {
      type: CASOS_LISTA,
      payload: {},
    };
  };
  
  export const casosCreate = (casos) => {
    return {
      type: CASOS_CREATE,
      payload: casos,
    };
  };
  export const casosCreateformData = (casos) => {
    return {
      type: CASOS_CREATE_FORM,
      payload: casos,
    };
  };
  
  export const casosFilter = (changeUrl) => {
    return {
      type: CASOS_FILTER,
      payload: { changeUrl },
    };
  };
  
  export const CasosRead = (id) => {
    return {
      type: CASOS_READ,
      payload: {id},
    };
  };

  export const CasosReadSuccess = (data) => {
    return {
      type: CASOS_READ_SUCCESS,
      payload: data,
    };
  };
  
  export const casosUpdate = (id, data) => {
    return {
      type: CASOS_UPDATE,
      payload: { id, data },
    };
  };
  
  export const casosListSuccess = (casos) => {
    return {
      type: CASOS_LIST_SUCCESS,
      payload: casos,
    };
  };
  export const casosFullListSuccess = (casos) => {
    return {
      type: CASOS_FULLLIST_SUCCESS,
      payload: casos,
    };
  };
  
  export const casosCreateSuccess = (casosCreated) => {
    return {
      type: CASOS_CREATE_SUCCESS,
      payload: casosCreated,
    };
  };
  export const casosCreateFormSuccess = (casosCreated) => {
    return {
      type: CASOS_CREATE_FORM_SUCCESS,
      payload: casosCreated,
    };
  };
  
  export const casosUpdateSuccess = (casos) => {
    return {
      type: CASOS_UPDATE_SUCCESS,
      payload: casos,
    };
  };
  
  export const casosRequestFailed = (error) => {
    return {
      type: CASOS_REQUEST_FAILED,
      payload: error,
    };
  };
  